import { verifyVendorToken } from "../views/Services/allServices";
// check is vendor login or not
export const isAuth = () => {
  const token = getAuth()
  if (token && token !== '') {
    return true
  }
  return false
}

// get accesstoken from localstorage
export const getAuth = () => {
  return localStorage.getItem('accesstoken')
}

// set accesstoken to localstorage
export const setAuth = token => {
  if (!token) return false
  try {
    localStorage.setItem('accesstoken', token)
    return true
  } catch (e) {
    return false
  }
}

// remove accesstoken from localstorage
export const removeToken = () => {
  deleteCookie('accesstoken');
  return localStorage.removeItem('accesstoken');
}

// function to get cookie value
const getCookie = (cname) => {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

// function to delete cookie by name
const deleteCookie = (cname) => {
  document.cookie = cname + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

// function to check authentication is vendor valid or not
export const isAuthenticated = () => {
  // console.log('Authentication in Process!');

  //get access token from the cookie
  const token = getCookie("accesstoken");
  if (token) {
    // console.log('True');
    setAuth(token);
    return true;
    // const data = {
    //   token: token
    // };

    // verifyVendorToken(data).then(res => {
    //   console.log('Response => => ', res.data.error);
    //   if (res.data.error) {
    //     console.log('false')
    //     deleteCookie('accesstoken');
    //     return false;
    //   }
    //   console.log('true');
    //   return true;
    // }).catch(err => {
    //   deleteCookie('accesstoken');
    //   console.log('false')
    //   return false;
    // });
  } else {
    // console.log('False')
    removeToken();
    return false;
  }
};
